import React from "react";
import "./style.css";
import MainHeading from "../../GlobalComponents/Utils/mainHeading";
import Button4 from "../../GlobalComponents/button3";
import { TbLayoutDashboardFilled } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import video1 from "../../Assets/highlights/video1.mp4";
import video2 from "../../Assets/highlights/video2.mp4";
import video3 from "../../Assets/highlights/video3.mp4";
import { useTranslation } from 'react-i18next';
export default function Marquee1() {
    const { t ,i18n} = useTranslation();
    const navigate = useNavigate();
    return (
        <div className="main_marquee">
            <div className="marquee1">
                <MainHeading
  align={'center'}
  flexDirection={'row'}
  gap={'10px'}
  width={'95%'}
  content1={t("portfolio.title").split(" ")[0] + " "}
  content2={t("portfolio.title").split(" ")[1]}
/>

                <p className='section_slogan'>
  {t("portfolio.description")}
</p>

                <div className="slider_marquee">
                    <div className="video_frame">
                        <video src={video1} autoPlay muted loop></video>
                    </div>
                    <div className="video_frame">
                        <video src={video2} autoPlay muted loop></video>
                    </div>
                    <div className="video_frame">
                        <video src={video3} autoPlay muted loop></video>
                    </div>
                    <div className="video_frame">
                        <video src="https://framerusercontent.com/assets/tioFfbYDZayFhDa0ksUzRE6jr5k.mp4" autoPlay muted loop></video>
                    </div>
                    <div className="video_frame">
                        <video src="https://framerusercontent.com/assets/RFoMiPXhXPJrUB5GiUwVKomXjg.mp4" autoPlay muted loop></video>
                    </div>
                    <div className="video_frame">
                        <video src="https://framerusercontent.com/assets/1e2A7OU7TBR3pI5QOeDg8cPUCI.mp4" autoPlay muted loop></video>
                    </div>
                    <div className="video_frame">
                        <video src="https://framerusercontent.com/assets/ipJDJDzyGh28f0srj26FErvHFE.mp4" autoPlay muted loop></video>
                    </div>
                    <div className="video_frame">
                        <video src="https://framerusercontent.com/assets/ipJDJDzyGh28f0srj26FErvHFE.mp4" autoPlay muted loop></video>
                    </div>
                    <div className="video_frame">
                        <video src="https://framerusercontent.com/assets/ipJDJDzyGh28f0srj26FErvHFE.mp4" autoPlay muted loop></video>
                    </div>
                    <div className="video_frame">

                    </div>
                    <div className="video_frame">

                    </div>
                    <div className="video_frame">

                    </div>
                </div>

            </div>
            <Button4
                text_1={t("portfolio.seeall")}
                text_2={t("portfolio.seeall")}
                iconComponent={TbLayoutDashboardFilled}
                width={"220px"}
                navigateClick={() => {
                    navigate("/our-projects")
                }} />
        </div>
    )
}